<template>
	<div>
		<sorting-visualizer></sorting-visualizer>
	</div>
</template>

<script>
	import SortingVisualizer from './components/SortingVisualizer'

	export default {
		components: {
			SortingVisualizer
		}
	}
</script>



// WEBPACK FOOTER //
// src/App.vue